(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
 document.querySelectorAll('[data-cart-check]').forEach(form=>{
  const notice=form.parentElement.querySelector('.bh-cart__notice');
  const root=window.Shopify?.routes?.root||'/';let busy=false;form.noValidate=true;
  const controls=[...form.querySelectorAll('button,input')];
  const originalDisabled=new Map(controls.map(el=>[el,el.disabled]));
  const originalCheckoutBlocked=Boolean(form.querySelector('[name="checkout"]')?.disabled);
  function unlock(){busy=false;form.removeAttribute('aria-busy');controls.forEach(el=>el.disabled=originalDisabled.get(el));}
  function saveNotice(message){try{sessionStorage.setItem('bh-cart-notice',message);}catch(error){}}
  function show(message){notice.textContent=message;notice.hidden=false;notice.focus();}
  let saved;try{saved=sessionStorage.getItem('bh-cart-notice');sessionStorage.removeItem('bh-cart-notice');}catch(error){}if(saved)show(saved);
  window.addEventListener('pageshow',event=>{if(event.persisted){unlock();window.location.reload();}});
  form.addEventListener('submit',async event=>{
   event.preventDefault();if(busy)return;
   const inputs=[...form.querySelectorAll('[data-line-key]')];
   if(inputs.some(input=>input.value.trim()===''||!Number.isSafeInteger(Number(input.value))||Number(input.value)<0)){show(form.dataset.invalid);return;}
   const requested=inputs.map(input=>({id:input.dataset.lineKey,quantity:Number(input.value)}));
   const checkout=event.submitter?.name==='checkout';if(checkout&&originalCheckoutBlocked)return;busy=true;form.setAttribute('aria-busy','true');
   controls.forEach(el=>el.disabled=true);show(form.dataset.updating);
   try{
    for(const item of requested){
     const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(item)});
     const data=await response.json();
     if(!response.ok){saveNotice(response.status===422?form.dataset.adjusted:form.dataset.error);window.location.assign(root+'cart');return;}
     const actual=data.items.find(line=>line.key===item.id)?.quantity||0;
     if(actual!==item.quantity){saveNotice(form.dataset.adjusted);window.location.assign(root+'cart');return;}
    }
    window.location.assign(root+(checkout?'checkout':'cart'));
   }catch(error){show(form.dataset.error);unlock();}
  });
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
 document.querySelectorAll('[data-gallery-target]').forEach(link=>link.addEventListener('click',e=>{
  const section=link.closest('.bh-product');const image=section.querySelectorAll('.bh-product__media')[Number(link.dataset.galleryTarget)];
  if(!image)return;e.preventDefault();image.scrollIntoView({behavior:'auto',block:'nearest',inline:'start'});
 }));
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    const section = select.closest('.bh-product');
    const price = section && section.querySelector('[data-product-price]');
    const button = form && form.querySelector('[data-add-to-cart]');
    const label = form && form.querySelector('[data-add-label]');
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price;
      if (button) button.disabled = !available;
      if (label) label.textContent = available ? select.dataset.availableLabel : select.dataset.soldOutLabel;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
